module.exports = __webpack_public_path__ + "static/media/done.62f61b73.svg";